import { UsageLimitToI18nKey } from '../constants/UsageLimitToI18nKey';
export const filterLimits = usageLimitsResponse => {
  if (!usageLimitsResponse || !usageLimitsResponse.length) {
    return [];
  }

  return usageLimitsResponse.filter(usageLimit => {
    return Object.keys(UsageLimitToI18nKey).includes(usageLimit.limitName);
  });
};
export const sortLimits = usageLimitsResponse => {
  if (!usageLimitsResponse || !usageLimitsResponse.length) {
    return [];
  }

  return usageLimitsResponse.sort((a, b) => a.limitName > b.limitName ? 1 : b.limitName > a.limitName ? -1 : 0);
};